import MentionInput from './MentionInput';

export default MentionInput;
